module.exports = __webpack_public_path__ + "img/in-use-noor-al-almer@1x.ef37d51f.jpg";